const MERCHANTS = {
  1: 'ios',
  2: 'android',
  3: 'ndrive',
  4: 'cybersource',
  5: 'manual'
}

export default {
  is (num, merchant) {
    return MERCHANTS[num] === merchant
  },
  get (num) {
    return MERCHANTS[num]
  },
  isPaid (num) {
    return this.is(num, 'android') || this.is(num, 'ios') || this.is(num, 'cybersource')
  }
}



// WEBPACK FOOTER //
// ./src/services/merchants.js